import styled from "styled-components";

export const HeaderContainer = styled.header`
  z-index: 1;
  display: flex;
  column-gap: 32px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  padding: 26px 48px;
  top: 0;
  position: fixed;
  border-bottom: 1px solid transparent;
  background-color: var(--veloprime-bg-primary);
  box-shadow: rgba(182, 193, 100, 0.08) 0px 8px 24px;

  img {
    @media only screen and (max-device-width: 390px) {
      margin: 0px;
    }
  }

  @media only screen and (max-device-width: 812px) {
    column-gap: 2px;
    padding: 13px 12px;
  }

  .buttons {
    display: flex;
    column-gap: 16px;

    @media only screen and (max-device-width: 812px) {
      column-gap: 2px;
    }

    button {
      height: 40px;
      font-weight: 500;
      color: var(--white);
      &.ant-btn-primary {
        border-color: var(--ant-primary-color);
        background-color: var(--ant-primary-color);
      }
    }
  }
`;
